import { Toaster as SonnerToaster } from 'sonner';

/**
 * Sonner-backed toast outlet. Mounted once near the root; submit success /
 * error notifications dispatch via `toast()` from `sonner` directly.
 */
export function Toaster() {
  return <SonnerToaster richColors closeButton position="top-right" />;
}
